import gql from 'graphql-tag';

export const GET_SERVICE_RUNS_DAILY_PICKLIST = gql`
	query(
		$page: Int,
		$perPage: Int,
		$sortBy: String,
		$sortDirection: Int,
		$filter: ServiceRunPageFilter
	) {
		getServiceRuns(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				id
				serviceDockets {
					id
					pickList {
						id
					}
					machine {
						id
						isOffline
						overridePredictiveGlobalSettings
						overrideUsePredictivePickLists
					}
				}
			}
			count
		}
	}
`;

export default GET_SERVICE_RUNS_DAILY_PICKLIST;
